import { Component, inject, Input, OnInit, OnChanges, SimpleChanges } from '@angular/core';
import { MaterialModule } from '../material-module';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { ContactService } from 'src/app/utility/services/contact/contact.service';

@Component({
    selector: 'app-part-lookup',
    imports: [MaterialModule, FormsModule, RouterModule],
    templateUrl: './part-lookup.component.html',
    styleUrl: './part-lookup.component.scss'
})
export class PartLookupComponent implements OnInit, OnChanges {

  @Input() profileId!: string;

  #contactService = inject(ContactService);

  partList: any[] = [];
  filteredParts: any[] = [];
  pagedParts: any[] = [];
  searchTerm: string = '';
  pageIndex: number = 0;
  pageSize: number = 10;

  ngOnInit(): void {
    if (this.profileId) {
      this.fetchParts();
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['profileId'] && this.profileId) {
      this.fetchParts();
    }
  }

  fetchParts() {
  this.#contactService.getPartsList(this.profileId).subscribe((data: any) => {
    // If data is a string, parse it
    if (typeof data === 'string') {
      try {
        this.partList = JSON.parse(data);
      } catch {
        this.partList = [];
      }
    } else {
      this.partList = data;
    }
    this.getFilteredParts();
  });
}

  getFilteredParts() {
    if (!this.searchTerm) {
      this.filteredParts = this.partList;
    } else {
      this.filteredParts = this.partList.filter(p =>
        p.Part?.toLowerCase().includes(this.searchTerm.toLowerCase())
      );
    }
    this.pageIndex = 0; // Reset to first page on filter
    this.updatePagedParts();
  }

  onPageChange(event: any) {
    this.pageIndex = event.pageIndex;
    this.updatePagedParts();
  }

  updatePagedParts() {
    const start = this.pageIndex * this.pageSize;
    const end = start + this.pageSize;
    this.pagedParts = this.filteredParts.slice(start, end);
  }
}
